t = require('views/internal/recup-with-helpers')('manage_members')

module.exports = t.statelessRenderable 'Member', ({ isSelected, member, toggleMember }) ->
  { avatarHash, fullName, initials, id, username } = member

  disabled = member.joined

  onClick = -> if !disabled then toggleMember(id)
  onKeyUp = (e) -> if !disabled && (e.key == 'Enter' || e.key == ' ') then onClick()

  selectedClass = if isSelected then '.checked' else ''
  titleText = "#{fullName} (#{username})"

  t.div '.member-wrapper', {
    class: t.classify('disabled': disabled)
    tabIndex: 0
    onClick
    onKeyUp
  }, ->
    t.div '.member', ->
      if avatarHash
        t.img '.member-avatar', {
          height: '32',
          width: '32',
          src: "#{ window.avatarDomain }/#{ avatarHash }/50.png"
          srcSet: "#{ window.avatarDomain }/#{ avatarHash }/50.png 1x, #{ window.avatarDomain }/#{ avatarHash }/50.png 2x"
          alt: titleText
          title: titleText
        }
      else
        t.span '.member-initials', { title: titleText }, ->
          t.text initials
    t.div '.full-name', -> t.text fullName
    t.div '.quiet', -> t.text '@' + username

    if !disabled
      t.div ".checkbox#{selectedClass}", ->
        t.span '.icon-lg.icon-check'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/member.coffee